import { isNotNil } from '@tryiris-ai/js-types';
import type { QuickShots } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Activate quick shots.
 *
 * @param deviceId - The ID of the device to be mutated.
 * @param intent - Movement intent.
 */
export const quickShots: QuickShots = async (deviceId, intent) => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      return;
    }

    // Send mutation
    const { pan, tilt, zoom } = intent;

    await proxy.mutate(
      {
        control: {
          device: {
            [deviceId]: {
              movement: {
                quickShots: {
                  pan: isNotNil(pan) ? pan : undefined,
                  tilt: isNotNil(tilt) ? tilt : undefined,
                  zoom: isNotNil(zoom) ? zoom : undefined
                }
              }
            }
          }
        }
      },
      {}
    );
  } catch (cause) {
    throw new StudioError('Unable to adjust quick shots.', { cause });
  }
};
